import * as authTokenManager from '../utils/tokenManager';

async function resetUser(ctx) {
  authTokenManager.removeToken();

  ctx.user = null;
  ctx.isLoggedIn = false;
}

export default resetUser;
